import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { InsuredFundBulkTradeResponse } from '../../Models/Models/Instruments/InsuredFundBulkTradeResponse';
import { InsuredFundBulkTradeCommand } from '../../Models/Models/Instruments/InsuredFundBulkTradeCommand';

declare var IS_RUNNING_IN_APP_POOL;

export class InsuredFundBulkTradingClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(command: InsuredFundBulkTradeCommand): Promise<InsuredFundBulkTradeResponse, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruments/InsuredFundBulkTrading/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { command: command }

    return AjaxWrapper.post<InsuredFundBulkTradeResponse, any>(url, data);
  }
}

